import React from 'react';
import PropTypes from 'prop-types';
import { Container, Span } from './styles';

const Label = ({ children, isRequired, spanStyle }) => (
  <Container>
    <Span isRequired={isRequired} style={spanStyle}>
      {children}
    </Span>
  </Container>
);

Label.defaultProps = {
  isRequired: false,
};

Label.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  isRequired: PropTypes.bool,
};

export default Label;
